import { render, staticRenderFns } from "@/templates/bookings/bookingTokenInfo.html?vue&type=template&id=a51c8916&scoped=true&"
import script from "./BookingTokenInfo.vue?vue&type=script&lang=js&"
export * from "./BookingTokenInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a51c8916",
  null
  
)

export default component.exports